module.exports = __webpack_public_path__ + "574cbd24f7e189b5797e91689cdccf12.svg";